/* AVENA MODE – Interaktionen (Hero-Video, Lookbook, FAQ, Bewertungen, Warenkorb-Staffel, Größenberater) */
(function(){
  'use strict';
  var $ = function(s, c){ return (c||document).querySelector(s); };
  var $$ = function(s, c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };

  /* ---------------- Hero-Video: 4 Szenen nacheinander, Desktop/Mobil ---------------- */
  function initHero(root){
    if (!root || root.dataset.avInit) return; root.dataset.avInit = '1';
    var mq = window.matchMedia('(max-width: 749px)');
    var holder = $('.avena-hero__media', root);
    var scenes = JSON.parse(root.getAttribute('data-scenes') || '[]');
    var dots = $$('.avena-hero__dots button', root);
    var vids = [], idx = 0, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!scenes.length || reduce) return;
    function build(){
      vids.forEach(function(v){ v.remove(); }); vids = [];
      var mobile = mq.matches;
      scenes.forEach(function(s, i){
        var v = document.createElement('video');
        v.muted = true; v.defaultMuted = true; v.playsInline = true; v.setAttribute('playsinline',''); v.setAttribute('muted','');
        v.preload = i === 0 ? 'auto' : 'metadata';
        v.setAttribute('aria-hidden','true'); v.setAttribute('tabindex','-1');
        v.poster = mobile ? s.posterM : s.posterD;
        v.src = mobile ? s.mobile : s.desktop;
        v.addEventListener('ended', next);
        holder.appendChild(v); vids.push(v);
      });
      idx = 0; show(0);
    }
    function show(i){
      clearTimeout(timer);
      vids.forEach(function(v, j){
        if (j === i){ v.classList.add('is-active'); try{ v.currentTime = 0; }catch(e){} var p = v.play(); if (p && p.catch) p.catch(function(){}); }
        else { v.classList.remove('is-active'); setTimeout(function(){ if(!v.classList.contains('is-active')) v.pause(); }, 1300); }
      });
      dots.forEach(function(d, j){ d.classList.toggle('is-active', j === i); d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      var n = vids[(i+1) % vids.length]; if (n) n.preload = 'auto';
      timer = setTimeout(next, 6500); // Fallback, falls "ended" nicht feuert
    }
    function next(){ idx = (idx + 1) % vids.length; show(idx); }
    dots.forEach(function(d, j){ d.addEventListener('click', function(){ idx = j; show(j); }); });
    if (mq.addEventListener) mq.addEventListener('change', build);
    if ('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){ var v = vids[idx]; if(!v) return; if (e.isIntersecting){ var p=v.play(); if(p&&p.catch)p.catch(function(){});} else v.pause(); }); }).observe(root);
    }
    build();
  }

  /* ---------------- Lookbook-Pfeile ---------------- */
  function initLook(root){
    if (!root || root.dataset.avInit) return; root.dataset.avInit = '1';
    var track = $('.avena-look__track', root);
    $$('[data-look-dir]', root).forEach(function(b){
      b.addEventListener('click', function(){
        var item = $('.avena-look__item', track); var w = item ? item.getBoundingClientRect().width + 12 : 300;
        track.scrollBy({ left: w * parseInt(b.getAttribute('data-look-dir'),10), behavior:'smooth' });
      });
    });
  }

  /* ---------------- FAQ-Kategorien ---------------- */
  function initFaq(root){
    if (!root || root.dataset.avInit) return; root.dataset.avInit = '1';
    var tabs = $$('.avena-faq__tab', root), cats = $$('.avena-faq__cat', root);
    tabs.forEach(function(t){
      t.addEventListener('click', function(){
        var k = t.getAttribute('data-cat');
        tabs.forEach(function(x){ x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        cats.forEach(function(c){ c.hidden = c.getAttribute('data-cat') !== k; });
      });
    });
  }

  /* ---------------- Bewertungs-Videos ---------------- */
  function initReviews(root){
    if (!root || root.dataset.avInit) return; root.dataset.avInit = '1';
    $$('.avena-rev__play', root).forEach(function(b){
      b.addEventListener('click', function(){
        var v = b.parentNode.querySelector('video'); if (!v) return;
        v.controls = true; v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function(){}); b.remove();
      });
    });
  }


  /* Lieferdatum (Bearbeitung 2–4 + Zustellung 3–4 Werktage → 5–8 Werktage) */
  function addWorkdays(d, n){ d = new Date(d); while (n > 0){ d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
  function fillEta(){
    var f = function(d){ return d.toLocaleDateString('de-DE', { weekday:'short', day:'numeric', month:'short' }); };
    $$('[data-avena-eta]').forEach(function(el){ if (el.dataset.done) return; el.dataset.done = '1'; var now = new Date(); el.textContent = f(addWorkdays(now, 5)) + ' – ' + f(addWorkdays(now, 8)); });
  }

  function initAll(scope){
    $$('[data-avena-hero]', scope).forEach(initHero);
    $$('[data-avena-look]', scope).forEach(initLook);
    $$('[data-avena-faq]', scope).forEach(initFaq);
    $$('[data-avena-reviews]', scope).forEach(initReviews);
    initSizeButtons();
    fillEta();
  }

  /* =========================================================
     GRÖSSENBERATER
     ========================================================= */
  var LETTERS = ['XXS','XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL','7XL'];
  var NORM = { 'XXL':'2XL','XXXL':'3XL','XXXXL':'4XL' };
  var DE_W = { 'XS':34,'S':36,'M':38,'L':40,'XL':42,'2XL':44,'3XL':46,'4XL':48,'5XL':50 };
  var DE_M = { 'XS':44,'S':46,'M':48,'L':50,'XL':52,'2XL':54,'3XL':56,'4XL':58,'5XL':60 };

  function sizeFieldset(){
    var fs = $$('variant-selects fieldset, variant-radios fieldset, .product-form__input');
    for (var i=0;i<fs.length;i++){
      var lg = fs[i].querySelector('legend, .form__label');
      if (lg && /gr(ö|oe|o)(ß|ss)e|size/i.test(lg.textContent)) return fs[i];
    }
    return null;
  }
  function sizeValues(fs){
    if (!fs) return [];
    var sel = fs.querySelector('select');
    if (sel) return $$('option', sel).map(function(o){ return { value:o.value, label:o.textContent.trim(), disabled:o.disabled || /nicht verfügbar|ausverkauft|unavailable/i.test(o.textContent) }; });
    return $$('input[type=radio]', fs).map(function(r){ return { value:r.value, label:r.value, disabled:r.classList.contains('disabled') }; });
  }

  function initSizeButtons(){
    var modal = $('#AvenaSizeAssistant'); if (!modal) return;
    var fs = sizeFieldset(); if (!fs || fs.querySelector('.avena-size-link')) return;
    var vals = sizeValues(fs);
    if (vals.length < 2) return; // Einheitsgröße → kein Berater
    var lg = fs.querySelector('legend, .form__label');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'avena-size-link'; btn.setAttribute('aria-haspopup','dialog');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 8h18v8H3z"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>Größenberater';
    btn.addEventListener('click', function(e){ e.preventDefault(); openSA(); });
    lg.appendChild(btn);
    var hint = document.createElement('p');
    hint.className = 'avena-pdp-sizehint';
    hint.innerHTML = 'Unsicher? <button type="button">In wenigen Sekunden zu Ihrer Größe</button> – mit unserem Größenberater.';
    hint.querySelector('button').addEventListener('click', openSA);
    fs.parentNode.insertBefore(hint, fs.nextSibling);
  }

  var SA = { step:0, data:{} };
  function openSA(){
    var m = $('#AvenaSizeAssistant'); if (!m) return;
    SA.step = 0; SA.data = {};
    $$('.avena-sa__opt', m).forEach(function(o){ o.setAttribute('aria-pressed','false'); });
    $$('input', m).forEach(function(i){ i.value = ''; });
    try { var saved = JSON.parse(localStorage.getItem('avenaSA') || '{}'); ['height','weight','foot'].forEach(function(k){ var el = m.querySelector('[name="'+k+'"]'); if (el && saved[k]) el.value = saved[k]; }); } catch(e){}
    renderStep(m);
    m.classList.add('is-open'); m.setAttribute('aria-hidden','false');
    document.body.classList.add('avena-noscroll');
    setTimeout(function(){ var f = m.querySelector('.avena-sa__step:not([hidden]) input, .avena-sa__step:not([hidden]) button'); if (f) f.focus(); }, 50);
  }
  function closeSA(){
    var m = $('#AvenaSizeAssistant'); if (!m) return;
    m.classList.remove('is-open'); m.setAttribute('aria-hidden','true');
    document.body.classList.remove('avena-noscroll');
    var b = $('.avena-size-link'); if (b) b.focus();
  }
  function steps(m){ return $$('.avena-sa__step', m); }
  function renderStep(m){
    var st = steps(m);
    st.forEach(function(s, i){ s.hidden = i !== SA.step; });
    $$('.avena-sa__progress span', m).forEach(function(p, i){ p.classList.toggle('is-done', i <= SA.step); });
    var err = $('.avena-sa__err', m); if (err) err.textContent = '';
  }
  function validate(m){
    var cur = steps(m)[SA.step]; var err = $('.avena-sa__err', m);
    var inputs = $$('input', cur);
    for (var i=0;i<inputs.length;i++){
      var v = parseFloat(String(inputs[i].value).replace(',','.'));
      var mn = parseFloat(inputs[i].min), mx = parseFloat(inputs[i].max);
      if (isNaN(v) || v < mn || v > mx){ err.textContent = 'Bitte geben Sie einen Wert zwischen ' + mn + ' und ' + mx + ' ein.'; inputs[i].focus(); return false; }
      SA.data[inputs[i].name] = v;
    }
    var groups = $$('[data-q]', cur);
    for (var j=0;j<groups.length;j++){
      var p = groups[j].querySelector('[aria-pressed="true"]');
      if (!p){ err.textContent = 'Bitte wählen Sie eine Antwort aus.'; return false; }
      SA.data[groups[j].getAttribute('data-q')] = parseFloat(p.getAttribute('data-v'));
    }
    return true;
  }

  function recommend(m){
    var kind = m.getAttribute('data-kind'); // damen|herren
    var cat = m.getAttribute('data-cat');   // oben|kleid|jacke|hose|schuh
    var d = SA.data, avail = sizeValues(sizeFieldset()).filter(function(v){ return !v.disabled; });
    var all = sizeValues(sizeFieldset());
    var why = [];
    if (cat === 'schuh'){
      var eu = d.foot ? Math.round((d.foot + 1.5) * 1.5 * 2) / 2 : 0;
      eu += (d.width || 0) * 0.5 + (d.sock || 0) * 0.5;
      why.push('Fußlänge ' + d.foot.toString().replace('.',',') + ' cm');
      if (d.width > 0) why.push('breiter Fuß'); if (d.sock > 0) why.push('dicke Wintersocken');
      return pickNumeric(all, avail, eu, why);
    }
    // Basis: Gewicht/Größe → Buchstabengröße
    var h = d.height, w = d.weight, bmi = w / Math.pow(h/100, 2), idx;
    if (kind === 'herren'){
      idx = w < 63 ? 1 : w < 73 ? 2 : w < 84 ? 3 : w < 95 ? 4 : w < 106 ? 5 : w < 117 ? 6 : w < 128 ? 7 : 8;
      if (h >= 190 && idx < 5) idx += 1;
    } else {
      idx = w < 52 ? 1 : w < 60 ? 2 : w < 68 ? 3 : w < 77 ? 4 : w < 87 ? 5 : w < 97 ? 6 : w < 108 ? 7 : 8;
      if (h >= 178 && (cat === 'kleid' || cat === 'jacke') && idx < 5) idx += 0.5;
    }
    if (bmi < 19 && idx > 1) idx -= 0.5;
    idx += (d.q1 || 0) * 0.6 + (d.q2 || 0) * 0.6 + (d.q3 || 0) * 0.6;
    why.push(h + ' cm, ' + w + ' kg');
    var l1 = $('[data-q="q1"] [aria-pressed="true"]', m), l2 = $('[data-q="q2"] [aria-pressed="true"]', m), l3 = $('[data-q="q3"] [aria-pressed="true"]', m);
    [l1,l2,l3].forEach(function(x){ if (x) why.push(x.getAttribute('data-label') || x.firstChild.textContent.trim()); });
    var r = Math.round(idx); if (r < 0) r = 0; if (r > LETTERS.length - 1) r = LETTERS.length - 1;
    var letter = LETTERS[r];
    var between = Math.abs(idx - r) >= 0.4;
    // Größen im Produkt numerisch (34–50 / 44–60)?
    var numeric = all.length && all.every(function(v){ return /^\d{2}$/.test(v.value.trim()); });
    if (numeric){ var map = kind === 'herren' ? DE_M : DE_W; return pickNumeric(all, avail, map[letter] || (kind==='herren'?50:40), why, between); }
    return pickLetter(all, avail, r, why, between);
  }
  function norm(v){ v = v.trim().toUpperCase(); return NORM[v] || v; }
  function pickLetter(all, avail, r, why, between){
    var best = null, bestD = 99;
    avail.forEach(function(v){ var i = LETTERS.indexOf(norm(v.value)); if (i < 0) return; var dd = Math.abs(i - r); if (dd < bestD){ bestD = dd; best = v; } });
    if (!best) return { none:true, why:why };
    var alt = null; if (between){ var i2 = LETTERS.indexOf(norm(best.value)) + 1; avail.forEach(function(v){ if (LETTERS.indexOf(norm(v.value)) === i2) alt = v; }); }
    return { size:best, alt:alt, why:why, off: bestD > 0 };
  }
  function pickNumeric(all, avail, target, why, between){
    var best = null, bestD = 99;
    avail.forEach(function(v){ var n = parseFloat(v.value.replace(',','.')); if (isNaN(n)) return; var dd = Math.abs(n - target); if (dd < bestD || (dd === bestD && n > parseFloat(best.value))){ bestD = dd; best = v; } });
    if (!best) return { none:true, why:why };
    return { size:best, alt:null, why:why, off: bestD > 1 };
  }

  function showResult(m){
    var res = recommend(m);
    var box = $('.avena-sa__result', m);
    try { localStorage.setItem('avenaSA', JSON.stringify({ height:SA.data.height, weight:SA.data.weight, foot:SA.data.foot })); } catch(e){}
    if (res.none){
      box.innerHTML = '<p class="avena-sa__eyebrow">Ihre Empfehlung</p><p class="avena-sa__why">Für Ihre Angaben ist dieses Modell leider gerade nicht in einer passenden Größe verfügbar. Schreiben Sie uns gern – wir finden eine Alternative.</p>';
      return;
    }
    box.innerHTML = '<p class="avena-sa__eyebrow">Ihre empfohlene Größe</p>' +
      '<div class="avena-sa__size">' + res.size.label + '</div>' +
      '<p class="avena-sa__why">Basierend auf: ' + res.why.join(' · ') + '.' + (res.off ? ' Ihre Idealgröße ist bei diesem Modell nicht verfügbar – dies ist die nächstliegende.' : '') + '</p>' +
      '<button type="button" class="avena-btn avena-btn--dark" data-sa-add style="width:100%">Größe ' + res.size.label + ' in den Warenkorb</button>' +
      (res.alt ? '<p class="avena-sa__alt">Sie liegen zwischen zwei Größen. Für mehr Bewegungsfreiheit: <button type="button" class="avena-size-link" data-sa-alt>Größe ' + res.alt.label + ' wählen</button></p>' : '') +
      '<p class="avena-sa__alt"><button type="button" class="avena-size-link" data-sa-only>Nur Größe übernehmen</button></p>';
    box.querySelector('[data-sa-add]').addEventListener('click', function(){ applySize(res.size, true, this); });
    var a = box.querySelector('[data-sa-alt]'); if (a) a.addEventListener('click', function(){ applySize(res.alt, true, box.querySelector('[data-sa-add]')); });
    box.querySelector('[data-sa-only]').addEventListener('click', function(){ applySize(res.size, false); });
  }

  function productForm(){ return $('product-form form[action*="/cart/add"]') || $('form[action*="/cart/add"][id^="product-form"]'); }
  function applySize(v, add, btn){
    var fs = sizeFieldset(); if (!fs) return;
    var f0 = productForm(), idEl0 = f0 && f0.querySelector('[name="id"]'), before = idEl0 ? idEl0.value : null, changed = false;
    var sel = fs.querySelector('select');
    if (sel){ if (sel.value !== v.value){ sel.value = v.value; changed = true; sel.dispatchEvent(new Event('change', { bubbles:true })); } }
    else {
      var r = $$('input[type=radio]', fs).filter(function(x){ return x.value === v.value; })[0];
      if (r && !r.checked){ r.checked = true; changed = true; r.dispatchEvent(new Event('change', { bubbles:true })); }
    }
    if (!add){ closeSA(); return; }
    if (btn){ btn.disabled = true; btn.textContent = 'Wird hinzugefügt …'; }
    var tries = 0;
    (function waitAndAdd(){
      tries++;
      var form = productForm();
      var idEl = form && form.querySelector('[name="id"]');
      var sub = form && form.querySelector('[type=submit]');
      var ready = !changed || (idEl && idEl.value !== before);
      var busy = !sub || sub.getAttribute('aria-disabled') === 'true' || sub.classList.contains('loading');
      if ((!ready || (busy && tries < 6)) && tries < 30){ return setTimeout(waitAndAdd, 120); }
      closeSA();
      if (sub && ready && sub.getAttribute('aria-disabled') !== 'true' && !sub.disabled) sub.click();
    })();
  }

  document.addEventListener('click', function(e){
    var m = $('#AvenaSizeAssistant'); if (!m || !m.contains(e.target)) return;
    var t = e.target.closest('button'); if (!t) { if (e.target.classList.contains('avena-sa__overlay')) closeSA(); return; }
    if (t.matches('.avena-sa__close')) return closeSA();
    if (t.matches('.avena-sa__opt')){
      var g = t.closest('[data-q]'); $$('.avena-sa__opt', g).forEach(function(o){ o.setAttribute('aria-pressed', o === t ? 'true' : 'false'); });
      return;
    }
    if (t.matches('[data-sa-next]')){
      if (!validate(m)) return;
      var n = steps(m).length;
      SA.step = Math.min(SA.step + 1, n - 1); renderStep(m);
      if (SA.step === n - 1) showResult(m);
      return;
    }
    if (t.matches('[data-sa-back]')){ SA.step = Math.max(0, SA.step - 1); renderStep(m); return; }
  });
  document.addEventListener('keydown', function(e){
    var m = $('#AvenaSizeAssistant'); if (!m || !m.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeSA();
    if (e.key === 'Enter' && e.target.tagName === 'INPUT'){ e.preventDefault(); var nb = $('.avena-sa__step:not([hidden]) [data-sa-next]', m); if (nb) nb.click(); }
  });

  /* Größen-Button nach Variantenwechsel neu setzen (Dawn rendert Picker neu) */
  if ('MutationObserver' in window){
    var pending = false;
    new MutationObserver(function(){ if (pending) return; pending = true; requestAnimationFrame(function(){ pending = false; initSizeButtons(); }); })
      .observe(document.documentElement, { childList:true, subtree:true });
  }


  /* =========================================================
     WARENKORB: Staffelrabatt-Leiste (2 = 10 %, 3 = 15 %, 4+ = 20 %) + Vertrauenszeile
     Wird bei jedem Neu-Rendern des Drawers eingesetzt (vor dem Zeichnen, kein Flackern).
     ========================================================= */
  var TIERS = [ { n:2, p:10 }, { n:3, p:15 }, { n:4, p:20 } ];
  var PAY_HTML = null;
  function drawerCount(inner){
    var n = 0;
    $$('.cart-items .quantity__input', inner).forEach(function(i){ n += parseInt(i.value, 10) || 0; });
    return n;
  }
  function tierHTML(n){
    var cur = 0, next = null;
    TIERS.forEach(function(t){ if (n >= t.n) cur = t.p; else if (!next) next = t; });
    var msg;
    if (n === 0) msg = 'Mehr kaufen, mehr sparen: <strong>ab 2 Artikeln 10 %</strong>, ab 3 Artikeln 15 %, ab 4 Artikeln 20 %.';
    else if (next){ var d = next.n - n; msg = (cur ? 'Sie sparen bereits <strong>' + cur + ' %</strong>. ' : '') + 'Noch <strong>' + d + ' Artikel</strong> bis <strong>' + next.p + ' % Rabatt</strong>.'; }
    else msg = 'Glückwunsch – Sie sparen <strong>20 %</strong> auf Ihre Bestellung.';
    var pct = n >= 4 ? 100 : [0, 8, 17, 50][n];
    var steps = TIERS.map(function(t){ return '<span class="' + (n >= t.n ? 'is-hit' : '') + '">' + t.n + ' Artikel · ' + t.p + ' %</span>'; }).join('');
    return '<p class="avena-tiers__msg">' + msg + '</p><div class="avena-tiers__bar" aria-hidden="true"><div class="avena-tiers__fill" style="width:' + pct + '%"></div></div><div class="avena-tiers__steps">' + steps + '</div>';
  }
  function trustHTML(){
    var ic = function(path){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' + path + '</svg>'; };
    return (PAY_HTML || '') +
      '<div class="avena-drawer-trust__row">' +
      '<span>' + ic('<rect x="5" y="10.5" width="14" height="10" rx="1.5"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/>') + 'Sichere Zahlung</span>' +
      '<span>' + ic('<path d="M4 9h11a5 5 0 0 1 0 10H8"/><path d="M8 5 4 9l4 4"/>') + '90 Tage Rückgabe</span>' +
      '<span>' + ic('<path d="M2 6h11v9H2z"/><path d="M13 9h4l3 3v3h-7z"/>') + 'Gratis Versand aus DE</span>' +
      '</div><div class="avena-drawer-trust__row"><span>PayPal: 30 Tage später zahlen · Käuferschutz</span></div>';
  }
  function decorateDrawer(){
    var inner = $('cart-drawer .drawer__inner'); if (!inner) return;
    if (PAY_HTML === null){ var tpl = $('#AvenaPayTemplate'); PAY_HTML = tpl ? tpl.innerHTML : ''; }
    var empty = !!$('.drawer__inner-empty', inner);
    var head = $('.drawer__header', inner);
    var bar = $('.avena-tiers', inner);
    if (!empty && head){
      var n = drawerCount(inner);
      if (!bar){ bar = document.createElement('div'); bar.className = 'avena-tiers'; bar.setAttribute('role','status'); head.insertAdjacentElement('afterend', bar); }
      if (bar.getAttribute('data-n') !== String(n)){ bar.setAttribute('data-n', n); bar.innerHTML = tierHTML(n); }
    } else if (bar) bar.remove();
    var ctas = $('.cart__ctas', inner);
    if (ctas && !$('.avena-drawer-trust', inner)){
      var t = document.createElement('div'); t.className = 'avena-drawer-trust'; t.innerHTML = trustHTML();
      ctas.insertAdjacentElement('afterend', t);
    }
  }
  if ('MutationObserver' in window){
    var drawerObs = new MutationObserver(function(){ decorateDrawer(); });
    var hookDrawer = function(){ var d = $('cart-drawer'); if (d && !d.dataset.avObs){ d.dataset.avObs = '1'; drawerObs.observe(d, { childList:true, subtree:true }); decorateDrawer(); } };
    document.addEventListener('DOMContentLoaded', hookDrawer);
    if (document.readyState !== 'loading') hookDrawer();
  }

  document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  if (document.readyState !== 'loading') initAll(document);
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();
